import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-[color:var(--border)] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="overline mb-4">LaneX Labs — Est. 2019</div>
            <h3 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Ready to build a<br />
              <span className="italic text-gradient">digital business?</span>
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta-quote"
              className="mt-8 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[color:var(--text)] text-[color:var(--bg)] font-semibold hover:opacity-90 transition-opacity"
            >
              Request a Quote
              <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-8 text-[13.5px]">
            <FooterCol title="Company" links={[
              ["About", "/about"], ["Insights", "/insights"], ["Careers", "/careers"], ["Contact", "/contact"],
            ]} />
            <FooterCol title="Services" links={[
              ["Websites", "/services"], ["E-Commerce", "/services"], ["Software", "/services"], ["Automation", "/services"],
              ["Hosting", "/hosting"], ["Business Email", "/email"],
            ]} />
            <FooterCol title="Work" links={[
              ["All Projects", "/work"], ["Industries", "/industries"], ["Case Studies", "/work"],
            ]} />
            <FooterCol title="Legal" links={[
              ["Privacy", "/privacy"], ["Terms", "/terms"], ["Cookies", "/privacy"],
            ]} />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[color:var(--border)] flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="text-[12px] text-[color:var(--text-muted)] font-mono tracking-wider">
            © {new Date().getFullYear()} LANEX LABS — A LANEX HOLDINGS COMPANY.
          </div>
          <div className="text-[12px] text-[color:var(--text-muted)] font-mono tracking-wider">
            BUILT WITH INTENT · LONDON · GLOBAL
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="overline mb-4">{title}</div>
      <ul className="space-y-2.5">
        {links.map(([label, href]) => (
          <li key={label}>
            <Link to={href} className="text-[color:var(--text-muted)] hover:text-[color:var(--text)] transition-colors">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
